import React, { useCallback } from 'react';

import { RoomsOfferedOptions, DealType } from '@search/filter-enums/enums';
import Checkbox from '@search/vtbeco-ui/src/components/controls/NewCheckbox';

import { RoomsInOfferFilter } from '../../../../models/Filter';
import { Filter2, IFilterAvailableProps } from '../../../new_filter/Filter2';
import { CheckboxGroup2, ICheckboxGroupModificationProps } from '../../../common/CheckboxGroup2';

interface IDesktopRoomsInOfferFilterViewProps extends ICheckboxGroupModificationProps, IFilterAvailableProps {
    filter: RoomsInOfferFilter;
    dealType: DealType;
    handleChange: (filter: RoomsInOfferFilter) => void;
}

const selectOptions = [ {
    value: RoomsOfferedOptions.ROOM_1,
    label: '1'
}, {
    value: RoomsOfferedOptions.ROOM_2,
    label: '2'
}, {
    value: RoomsOfferedOptions.ROOM_3,
    label: '3'
}, {
    value: RoomsOfferedOptions.ROOM_4_AND_MORE,
    label: '4+'
} ];

export const DesktopRoomsInOfferFilterView: React.FC<IDesktopRoomsInOfferFilterViewProps> = ({
    filter,
    dealType,
    handleChange,
    withoutTitle,
    classNameGroup
}) => {
    const onChange = useCallback(value => {
        handleChange(new RoomsInOfferFilter(value));
    }, [ handleChange ]);

    const filterTitle = dealType === DealType.RENT ? 'Комнат в аренду' : 'Комнат на продажу';

    return (
        <Filter2
            filterTitle={withoutTitle ? undefined : filterTitle}
        >
            <CheckboxGroup2
                mode='check'
                onChange={onChange}
                name='roomInOffer'
                value={filter.roomsInOffer}
                withoutGrid
                classNameGroup={classNameGroup}
            >
                {selectOptions.map(({ value, label }) => (
                    <Checkbox
                        type='button'
                        view='primary'
                        tone='secondary'
                        key={value}
                        value={value}
                    >
                        {label}
                    </Checkbox>
                ))}
            </CheckboxGroup2>
        </Filter2>
    );
};
